import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

declare interface RouteInfo {
  img: string;
  text1: string;
  text2: string;
  text3: string;
  text4: string;
}

export const AnnualConventionContent: RouteInfo[] = [
  {
    img: '../../../assets/images/CarouselEventFlyers/AnnualStatewideConvention.png',
    text1:
      'The CHCC’s Annual Statewide Convention is the largest networking venue for Hispanic businesses in the western region. For forty years, the CHCC has served as a leading regional Hispanic business organization in the United States, working to bring the interests of the more than 815,000 California Hispanic-owned businesses to the forefront of both the California and national economic agendas.',
    text2:
      'Whether you are joining us as a corporate executive, agency representative, private business owner, participating as a chamber member, or community leader, we truly appreciate your interest in this year’s convention and your support of the CHCC and our local Hispanic chambers.',
    text3:
      'Each year, our Annual Statewide Convention gathers Hispanic business owners, corporate executives, and members from over 120 local and regional Hispanic Chambers of Commerce and diverse business associations statewide, as well as from throughout the nation. It offers all attendees the opportunity to establish strategic, long-lasting partnerships through direct personal engagement, sharing of best practices, dialogue, networking, workshops, and more. As our organization grows and thrives, we look to seek inspiration from individuals who are willing to take risks, achieve, and inspire others.',
    text4:
      'We look forward to you joining us as we continue our work to champion smart practices and policies that lead to growth and innovation. The CHCC looks forward to celebrating as a business community the successes we have grown together, and to an economic future we are driving together.',
  },
];
@Component({
    selector: 'app-annual-convention',
    templateUrl: './annual-convention.component.html',
    styleUrls: ['./annual-convention.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnnualConventionComponent implements OnInit {
  mainTitle = 'Annual Convention';
  texts: any = [];

  constructor() {}

  ngOnInit(): void {
    this.texts = AnnualConventionContent.filter((text) => text);
  }
}
